import { render } from "./ChildRecord.vue?vue&type=template&id=42828dff&ts=true"
import script from "./ChildRecord.vue?vue&type=script&lang=ts"
export * from "./ChildRecord.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__